import { z } from "zod";
import { paginationMetaSchema } from "../interfaces/base-api-response";

/** Mirrors backend `OrderStatus` — used for admin list and GET order details. */
export enum AdminOrderStatus {
  DRAFT = "DRAFT",
  CONFIRMED = "CONFIRMED",
  CANCELLED = "CANCELLED",
}

export enum AdminOrderFulfillmentStatus {
  UNFULFILLED = "UNFULFILLED",
  PARTIALLY_FULFILLED = "PARTIALLY_FULFILLED",
  FULFILLED = "FULFILLED",
}

export enum AdminOrderPaymentMode {
  PREPAID = "PREPAID",
  POSTPAID = "POSTPAID",
  BOOKING_FEE = "BOOKING_FEE",
}

export enum AdminOrderPaymentStatus {
  PENDING = "PENDING",
  PARTIALLY_COLLECTED = "PARTIALLY_COLLECTED",
  COLLECTED = "COLLECTED",
  VERIFIED = "VERIFIED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
}

export enum OrderPaymentStatus {
  PENDING = "PENDING",
  PARTIALLY_PAID = "PARTIALLY_PAID",
  PAID = "PAID",
}

const petBasicInfoSchema = z.object({
  id: z.string(),
  name: z.string(),
  breedName: z.string(),
  profilePicUrl: z.string().nullish(),
});

const userBasicPublicInfoSchema = z.object({
  id: z.string(),
  name: z.string(),
  profilePicUrl: z.string().nullish(),
  petProfiles: z.array(petBasicInfoSchema).nullish(),
});

export const adminOrderResponseSchema = z.object({
  id: z.string(),
  user: userBasicPublicInfoSchema.nullish(),
  status: z.nativeEnum(AdminOrderStatus),
  fulfillmentStatus: z.nativeEnum(AdminOrderFulfillmentStatus).nullish(),
  paymentMode: z.nativeEnum(AdminOrderPaymentMode),
  paymentStatus: z.nativeEnum(OrderPaymentStatus).nullish(),
  subTotal: z.number(),
  total: z.number(),
  totalSavings: z.number().nullish(),
  source: z.string().nullish(),
  createdAt: z.number(),
  updatedAt: z.number(),
});

export type AdminOrderResponseDto = z.infer<typeof adminOrderResponseSchema>;

export const adminOrdersListResponseSchema = z.object({
  items: z.array(adminOrderResponseSchema),
  meta: paginationMetaSchema,
});

export type AdminOrdersListResponseDto = z.infer<typeof adminOrdersListResponseSchema>;

export interface SearchAdminOrdersParams {
  page?: number;
  limit?: number;
  serviceCategory?: string[];
  createdAtFrom?: number;
  createdAtTo?: number;
  status?: AdminOrderStatus;
  paymentStatus?: string;
  fulfillmentStatus?: AdminOrderFulfillmentStatus;
  query?: string;
  userId?: string;
}
